<template>
  <div class="d-flex flex-column">
    <button type="button" class="m-1 btn btn-primary" @click="showContract" :disabled="btnContract.disabled">{{ btnContract.text }}</button>
    <button type="button" class="m-1 btn btn-primary" @click="showSigned" :disabled="btnSigned.disabled">{{ btnSigned.text }}</button>
  </div>
</template>
<script >
export default {
  props: ["contract", "signed", "approved"],
  data() {
    return {
      btnContract: {
        text: "Ver contrato",
        link: JSON.parse(this.contract).contract,
        disabled: !this.approved,
      },
      btnSigned: {
        text: "Ver contrato Autentique",
        link: JSON.parse(this.contract).contract_signed_link,
        disabled: !this.signed,
      },
    };
  },
  methods: {
    showContract() {
      window.open(this.btnContract.link, '_blank');
    },
    showSigned() {
      window.open(this.btnSigned.link, '_blank');
    },
  }
}
</script>